module.exports = __webpack_public_path__ + "img/h3_banner.f6c45f00.png";